export const EVAL_EVALUATOR_KIND_DEFINITIONS = [
  {
    kind: "exact_match_path",
    displayName: "Exact match (path)",
    description: "Strict equality between predicted and expected values at one JSON path.",
  },
  {
    kind: "fuzzy_match_path",
    displayName: "Fuzzy match (path)",
    description: "Levenshtein similarity between predicted and expected values at one JSON path.",
  },
] as const;

export const EVAL_EVALUATOR_KINDS = EVAL_EVALUATOR_KIND_DEFINITIONS.map(
  (definition) => definition.kind,
);

export type EvalEvaluatorKind = (typeof EVAL_EVALUATOR_KIND_DEFINITIONS)[number]["kind"];

const EVAL_EVALUATOR_KIND_SET: ReadonlySet<string> = new Set(EVAL_EVALUATOR_KINDS);

export function isEvalEvaluatorKind(kind: string): kind is EvalEvaluatorKind {
  return EVAL_EVALUATOR_KIND_SET.has(kind);
}

export function getEvalEvaluatorKindDefinition(kind: string) {
  return EVAL_EVALUATOR_KIND_DEFINITIONS.find((definition) => definition.kind === kind) ?? null;
}
